/*
 *
 * RootModal
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectModalType, selectModalProps } from './selectors';
import { clearModal } from './actions';
import {
  INVALID_EMAIL,
  INVALID_PASSWORD,
  PASSWORD_REQUIREMENTS,
  LOGIN_ERROR,
  COLOR_PICKER,
  PLAN_SELECTION,
  INTUITIVE_MODAL,
  UPGRADE_TO_ENTERPRISE_MODAL,
  HAS_ALREADY_SIGNED_UP_MODAL,
  UNVERIFIED_EMAIL_MODAL,
  VERIFICATION_RESENT_SUCCESS_MODAL,
  VERIFICATION_RESENT_FAILURE_MODAL,
  LAPSED_MODAL
} from "./constants";

import InvalidEmailModal from 'components/InvalidEmailModal';
import InvalidPasswordModal from 'components/InvalidPasswordModal';
import PasswordRequirementsModal from 'components/PasswordRequirementsModal';
import LoginErrorModal from 'components/LoginErrorModal';
import ColorPickerModal from 'components/ColorPickerModal';
import PlanSelectionModal from 'components/PlanSelectionModal';
import LapsedModal from 'components/LapsedModal';
import IntuitiveModal from 'components/IntuitiveModal';
import UpgradeToEnterpriseModal from 'components/UpgradeToEnterpriseModal';
import HasAlreadySignedUpModal from 'components/HasAlreadySignedUpModal';
import UnverifiedEmailModal from 'components/UnverifiedEmailModal';
import VerificationResentSuccessModal from 'components/VerificationResentSuccessModal';
import VerificationResentFailureModal from 'components/VerificationResentFailureModal';

const MODAL_COMPONENTS = {
  [INVALID_EMAIL]: InvalidEmailModal,
  [INVALID_PASSWORD]: InvalidPasswordModal,
  [PASSWORD_REQUIREMENTS]: PasswordRequirementsModal,
  [LOGIN_ERROR]: LoginErrorModal,
  [COLOR_PICKER]: ColorPickerModal,
  [PLAN_SELECTION]: PlanSelectionModal,
  [INTUITIVE_MODAL]: IntuitiveModal,
  [UPGRADE_TO_ENTERPRISE_MODAL]: UpgradeToEnterpriseModal,
  [HAS_ALREADY_SIGNED_UP_MODAL]: HasAlreadySignedUpModal,
  [UNVERIFIED_EMAIL_MODAL]: UnverifiedEmailModal,
  [VERIFICATION_RESENT_SUCCESS_MODAL]: VerificationResentSuccessModal,
  [VERIFICATION_RESENT_FAILURE_MODAL]: VerificationResentFailureModal,
  [LAPSED_MODAL]: LapsedModal,
};

export const RootModal = ({ modalType, modalProps, close }) => {
  if(!!modalType) {
    const SpecificModal = MODAL_COMPONENTS[modalType];
    return (<SpecificModal modalProps={modalProps} close={close} />);
  } else {
    return (<div />);
  }
};

const mapStateToProps = createStructuredSelector({
  modalType: selectModalType(),
  modalProps: selectModalProps(),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(clearModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RootModal);



// WEBPACK FOOTER //
// ./src/containers/RootModal/index.js